<template>
  <form @submit.prevent="submitForm()" novalidate>
    <div>
      <mu-row gutter>
        <mu-col width="80" desktop="50" tablet="70">
          <mu-row gutter>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-time-picker
                :label="$t('message.labelTime')"
                mode="portrait"
                fullWidth
                v-model="timeModel.time"
                :okLabel="$t('message.okText')"
                :cancelLabel="$t('message.cancelText')"
              ></mu-time-picker>
            </mu-col>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-date-picker
                :label="$t('message.labelDate')"
                :okLabel="$t('message.okText')"
                :cancelLabel="$t('message.cancelText')"
                :dateTimeFormat="dateFormat"
                format="DD-MM-YYYY"
                v-model="timeModel.date"
                :maxDate="maxDate"
                fullWidth
              ></mu-date-picker>
            </mu-col>
          </mu-row>
          <mu-row gutter>
            <mu-col width="100" tablet="100" desktop="50">
              <mu-text-field
                v-validate
                :data-vv-rules="'required|min_value:0|max_value:250'"
                data-vv-name="units"
                data-vv-value-path="inputValue"
                :errorText="errors.first('units')"
                type="number"
                :label="$t('message.labelUnits')"
                v-model.number="reading.units"
                :hintText="`${$t('message.cardInsulin')} ${lowerCaseUnitsLabel}`"
                :fullWidth="true"
              />
            </mu-col>
            <mu-col width="100" tablet="100" desktop="50">
              <mu-select-field
                hintText="$t('message.selectText')"
               v-model="reading.type"
               v-validate
               :data-vv-rules="'required'"
               data-vv-name="insulin_type"
               data-vv-value-path="inputValue"
               :errorText="errors.first('insulin_type')"
               :label="$t('message.labelInsulinType')"
               :fullWidth="true">
                <mu-menu-item
                  v-for="(type, index) in insulinTypes"
                  :key="'insulin-type-' + index"
                  :value="type.insulin_type_id"
                  :title="mapInsulinTypes(type.type)"/>
              </mu-select-field>
            </mu-col>
          </mu-row>
        </mu-col>
      </mu-row>


    </div>
    <mu-flat-button
      style="margin-right: 8px;"
      :label="$t('message.discardText')"
      @click.native="closeEditMode(reading)"
    ></mu-flat-button>

    <button type="submit" style="display: none;"></button>

    <mu-raised-button
      @click.native="submitForm"
      :disabled="isUpdating"
      :label="isUpdating ? $t('message.updatingText') : $t('message.updateText')"
      type="button"
      secondary
    ></mu-raised-button>
  </form>
</template>
<script>

  import InsulinApi from '../../../../api/Tracking/Insulin'
  import TrackingEditMixin from '../../../../mixins/TrackingEditMixin'
  import InsulinMixin from '../../../../mixins/InsulinMixin'

  export default {
    mixins: [
      TrackingEditMixin,
      InsulinMixin
    ],
    name: 'insulin-edit',
    props: {
      insulinTypes: {
        type: Array,
        required: true,
        default: []
      },
      item: {
        type: Object,
        required: true,
        default: {}
      }
    },
    data() {
      return {
        isUpdating: false,
        reading: {}
      }
    },
    mounted() {
      let self = this;
    },
    methods: {
      submitForm() {
        let self = this;
        self.$validator.validateAll().then(function (valid) {
          if (valid) {
            self.isUpdating = true;
            InsulinApi.putInsulinTracking(self.reading)
              .then(function (response) {
                let offset = new Date();
                self.reading.date_created = moment(self.reading.date).add(offset.getTimezoneOffset().toString().replace('-', ''), 'minutes')
                self.$emit('updateReading', self.reading);
                self.$emit('closeEditPanel');
                self.isUpdating = false;
              });

          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// InsulinEdit.vue?e80fed1c